import './App.css';
import { BrowserRouter, Route } from 'react-router-dom';
import RaktkoshDashboard from './components/pages/raktkoshDashboard'
import { HashRouter, Switch } from 'react-router-dom/cjs/react-router-dom.min';
import Test from './components/pages/Test';

function App() {
  return (
    <HashRouter  basename="/">
      <Switch>
        <Route exact path='/'>
          <RaktkoshDashboard />
        </Route>
        <Route exact path='/test'>
          <Test/>
        </Route>
      </Switch>
    </HashRouter>
  );
}

export default App;
